const API_BASE = import.meta.env.VITE_API_BASE_URL ?? "";

export async function subscribeToWaitlist(data: {
  name: string;
  email: string;
  phone?: string;
}) {
  const { name, email, phone } = data;

  if (!name || !email) {
    throw new Error("Nombre y correo electrónico son requeridos");
  }

  const response = await fetch(`${API_BASE}/api/subscribe`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    body: JSON.stringify({
      name,
      email,
      phone: phone || "",
      source: "taxby-website",
    }),
  });

  const result = await response.json().catch(() => ({}));

  if (!response.ok) {
    throw new Error(
      typeof result.error === "string"
        ? result.error
        : "Error al procesar la suscripción"
    );
  }

  return result;
}
